<template>
    <b-row>
        <b-col sm="12" md="12" lg="12" xl="12">
            <b-card no-body>
                <b-card-header>
                    <span class="h5">
                        CONTRATAÇÃO -
                        <b-badge variant="warning">{{ operacao }}</b-badge>
                    </span>
                </b-card-header>
                <b-card-body>
                    <b-row>
                        <b-col sm="12" md="4">
                            <app-k-v
                                titulo="Código"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="contratacao.codContratacao"
                            ></app-k-v>
                            <app-k-v
                                titulo="Unidade"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="contratacao.unidade"
                            ></app-k-v>
                            <app-k-v
                                titulo="Gestor"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="contratacao.gestor"
                            ></app-k-v>
                            <app-k-v
                                titulo="Gestor Designado"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                v-if="contratacao.gestorDesignado"
                                ><strong
                                    >{{ contratacao.gestorDesignado
                                    }}<span
                                        v-if="contratacao.fimDesignacaoGestor"
                                    >
                                        até
                                        {{
                                            $moment(
                                                contratacao.fimDesignacaoGestor
                                            ).format('DD/MM/YYYY')
                                        }}</span
                                    ></strong
                                ></app-k-v
                            >
                            <app-k-v
                                titulo="Gerente"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="contratacao.gerente"
                            ></app-k-v>
                            <app-k-v
                                titulo="Natureza"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                            >
                                <app-status
                                    :status="
                                        contratacao.natureza
                                            ? contratacao.natureza
                                            : ''
                                    "
                                ></app-status>
                            </app-k-v>
                            <app-k-v
                                titulo="Fornecedor"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="contratacao.credenciado"
                            ></app-k-v>
                            <app-k-v
                                titulo="Qtd Entregas"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="contratacao.qtdEntregas"
                            ></app-k-v>
                            <app-k-v
                                titulo="Período"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                            >
                                <strong>
                                    {{
                                        contratacao.dataInicio
                                            ? $moment(
                                                  contratacao.dataInicio
                                              ).format('DD/MM/YYYY')
                                            : ''
                                    }}
                                    -
                                    {{
                                        contratacao.dataFim
                                            ? $moment(
                                                  contratacao.dataFim
                                              ).format('DD/MM/YYYY')
                                            : ''
                                    }}
                                </strong>
                            </app-k-v>
                            <app-k-v
                                titulo="Valor Total"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                            >
                                <strong>{{
                                    contratacao.valorTotal | currency
                                }}</strong>
                            </app-k-v>
                            <app-k-v
                                titulo="Situação"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                            >
                                <app-status
                                    :status="
                                        contratacao.situacaoDescr
                                            ? contratacao.situacaoDescr
                                            : ''
                                    "
                                ></app-status>
                            </app-k-v>
                            <app-k-v
                                titulo="Atualizado em"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                            >
                                <strong>{{
                                    contratacao.dataAtualizacao
                                        ? $moment(
                                              contratacao.dataAtualizacao
                                          ).format('DD/MM/YYYY HH:mm')
                                        : ''
                                }}</strong>
                            </app-k-v>
                        </b-col>
                        <b-col sm="12" md="5">
                            <app-k-v
                                titulo="Objeto"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                :dado="contratacao.objeto"
                            ></app-k-v>
                        </b-col>
                        <b-col sm="12" md="3">
                            <app-contratacao-natureza
                                :natureza="consultoria"
                                :movimentosServicos="movimentosServicos"
                                :contratacoesServicos="contratacoesServicos"
                                v-if="
                                    contratacao.idNatureza === 0 ||
                                    contratacao.idNatureza === 2
                                "
                                @obterAtualizacao="$emit('obterAtualizacao')"
                            ></app-contratacao-natureza>
                            <app-contratacao-natureza
                                :natureza="instrutoria"
                                :contratacoesServicos="contratacoesServicos"
                                :movimentosServicos="movimentosServicos"
                                v-if="
                                    contratacao.idNatureza === 1 ||
                                    contratacao.idNatureza === 2
                                "
                                @obterAtualizacao="$emit('obterAtualizacao')"
                            ></app-contratacao-natureza>
                        </b-col>
                    </b-row>
                </b-card-body>
                <b-card-footer>
                    <slot name="footer" v-bind="contratacao"></slot>
                </b-card-footer>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import ContratacaoNatureza from './ContratacaoNatureza'

export default {
    props: {
        contratacao: {
            type: Object,
            default: () => ({})
        },

        movimentosServicos: {
            type: Object,
            default: () => ({})
        },

        contratacoesServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            operacao: 'DETALHAR',
            xl: 3,
            lg: 3,
            md: 2
        }
    },

    computed: {
        consultoria() {
            return {
                codContratacao: this.contratacao.codContratacao,
                nome: 'CONSULTORIA',
                cargaHoraria: this.contratacao.cargaHorariaConsultoria,
                valorHora: this.contratacao.valorHoraConsultoria,
                valorDespViagem: this.contratacao.valorDespViagemConsultoria,
                valorDespViagemAjustado:
                    this.contratacao.valorDespViagemConsultoriaAjustado,
                valorTotal: this.contratacao.valorTotalConsultoria,
                status: this.contratacao.statusIdRmDespViagemConsultoriaDescr,
                idRm: this.contratacao.idRmDespViagemConsultoria,
                statusFin: this.contratacao.statusFinIdRmDespViagemConsultoria,
                pagamento: this.contratacao.pagamentoConsultoria,
                justificativa:
                    this.contratacao
                        .justificativaValorDespViagemConsultoriaAjustado,
                cancelada: this.contratacao.despViagemConsultoriaCancelada,
                justificativaCancelamento:
                    this.contratacao
                        .justificativaDespViagemConsultoriaCancelada,
                dataReprogramada:
                    this.contratacao.dataReprogramadaDespViagemConsultoria,
                justificativaDataReprogramada:
                    this.contratacao
                        .justificativaDataReprogramadaDespViagemConsultoria
            }
        },

        instrutoria() {
            return {
                codContratacao: this.contratacao.codContratacao,
                nome: 'INSTRUTORIA',
                cargaHoraria: this.contratacao.cargaHorariaInstrutoria,
                valorHora: this.contratacao.valorHoraInstrutoria,
                valorDespViagem: this.contratacao.valorDespViagemInstrutoria,
                valorDespViagemAjustado:
                    this.contratacao.valorDespViagemInstrutoriaAjustado,
                valorTotal: this.contratacao.valorTotalInstrutoria,
                status: this.contratacao.statusIdRmDespViagemInstrutoriaDescr,
                idRm: this.contratacao.idRmDespViagemInstrutoria,
                statusFin: this.contratacao.statusFinIdRmDespViagemInstrutoria,
                pagamento: this.contratacao.pagamentoInstrutoria,
                justificativa:
                    this.contratacao
                        .justificativaValorDespViagemInstrutoriaAjustado,
                cancelada: this.contratacao.despViagemInstrutoriaCancelada,
                justificativaCancelamento:
                    this.contratacao
                        .justificativaDespViagemInstrutoriaCancelada,
                dataReprogramada:
                    this.contratacao.dataReprogramadaDespViagemInstrutoria,
                justificativaDataReprogramada:
                    this.contratacao
                        .justificativaDataReprogramadaDespViagemInstrutoria
            }
        }
    },

    components: {
        AppContratacaoNatureza: ContratacaoNatureza
    }
}
</script>
